import { Box, Typography, Paper, Button } from '@material-ui/core';
import { useSearchParams } from 'react-router-dom';
import { useStyles } from './styles';

export default function ErrorPage() {
  const classes = useStyles();
  const [params] = useSearchParams();
  const msg = params.get('msg');

  return (
    <Box className={classes.container}>
      <Paper elevation={3} className={classes.paper}>
        <Typography variant="h4" gutterBottom>
          Hmm, seems like an error occurred 🤖
        </Typography>

        <Typography variant="body1" color="textSecondary" gutterBottom>
          We logged this error and our team will investigate.
        </Typography>

        {msg && <pre className={classes.msgBox}>{msg}</pre>}

        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={() => window.location.replace('/')}
        >
          Go back home
        </Button>
      </Paper>
    </Box>
  );
}
